import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateTeamType, ResponseTeamType, TeamType, UpdateTeamType } from '../state/types';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class TeamService extends BLService {
  private RESOURCE_ENDPOINT = 'team';

  getTeams(): Observable<TeamType[]> {
    return this.httpGet<TeamType[]>(this.RESOURCE_ENDPOINT);
  }

  addTeam(team: CreateTeamType): Observable<TeamType> {
    return this.httpPost<ResponseTeamType>(this.RESOURCE_ENDPOINT, team).pipe(
      map((team) => this.transformToTeamType(team)),
    );
  }

  updateTeam(team: UpdateTeamType): Observable<TeamType> {
    return this.httpPatch<ResponseTeamType>(`${this.RESOURCE_ENDPOINT}/${team.id}`, team).pipe(
      map((responseTeam) => this.transformToTeamType(responseTeam)),
      this.catchErrorAndShowMessage(),
    );
  }

  deleteTeam(team: TeamType): Observable<void> {
    return this.httpDelete<never>(`${this.RESOURCE_ENDPOINT}/${team.id}`);
  }

  // eslint-disable-next-line complexity
  private transformToTeamType(team: ResponseTeamType): TeamType {
    const mapToIds = (array: { id: number }[]) => array.map((item) => item.id);
    const { users, clients, tasks, ...rest } = team;

    const userIds = mapToIds(users?.data || []);
    const clientIds = mapToIds(clients?.data || []);
    const taskIds = mapToIds(tasks?.data || []);

    return {
      ...rest,
      users: { ...users, data: userIds },
      clients: { ...clients, data: clientIds },
      tasks: { ...tasks, data: taskIds },
    };
  }
}
